import React from "react";

import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"; // Replace with your icon setup

const SearchBar: React.FC = () => {
  return (
    <div className="flex bg-gray-100 rounded-2xl px-3 py-4">
      <MagnifyingGlassIcon className="h-6 w-6 text-black-500" />
      <input
        type="text"
        placeholder="Rechercher un projet"
        className="text-black-500 text-sm border-none bg-transparent pl-2 outline-none focus:ring-0"
      />
    </div>
  );
};

export default SearchBar;